<template>
  <span
    :class="spanClass"
    @click="handleClick"
    :disabled="spanDisabled || (showLoading && isLoading)">
    <i class="el-icon-loading" v-if="showLoading && isLoading"></i>
    <slot></slot>
  </span>
</template>

<script>
  import {qunjiReject, qunjiResolve} from 'qunji-common-vue-pc/src/utils/common'

  export default {
    name: 'qunji-span',
    props: {
      spanClass: {
        type: String
      },
      spanDisabled: {
        type: Boolean,
        default: false
      },
      showLoading: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        isLoading: false
      }
    },
    methods: {
      handleClick(evt) {
        this.isLoading = true
        let resolve = response => {
          this.isLoading = false
          qunjiResolve(response, this)
        }
        let reject = error => {
          this.isLoading = false
          qunjiReject(error, this)
        }
        this.$emit('click', resolve, reject, evt)
      }
    }
  }
</script>
